// extracted by mini-css-extract-plugin
module.exports = {"makeLogoWithTitle":"MakeWithLogo_makeLogoWithTitle__Xsac2","image":"MakeWithLogo_image___Vn_E","reviewHeader":"MakeWithLogo_reviewHeader__Uq1Cw"};